<template>
   <div class="yk-choice-main yk-choice-main-s-new">
       <el-form ref="form" :model="form" label-width="80px" class="yk-form">
           <div class="yk-question">
                <el-form-item label="题型">
                    <el-select placeholder="选择题型" v-model="numType" @change="changeType">
                        <el-option v-for="item in form.queType" :key="item.value" :label="item.label" :value="item.value">
                       </el-option>
                   </el-select>
               </el-form-item>
               <el-form-item label="难度">
                    <el-select v-model="diffTypeValue">
                        <el-option v-for="item in form.diffType" :key="item.value" :label="item.label" :value="item.value">
                       </el-option>
                   </el-select>
              </el-form-item>
           </div>
           <el-form-item :label="numType!=6?'题目':'题干'" style="width:700px;">
                <Editor v-model="stemContent" placeholder="请输入题干"/>
           </el-form-item>
           <el-form-item :label="numType!=6?'题目附件':'题干附件'" style="width:700px;">
                  <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList"></QuestionFile>
           </el-form-item>
            <!-- 单选 -->
           <el-form-item label="选项" class="yk-radioChoice" v-if="numType == 1">
               <div class="yk-op-choice-child" v-for="(item,index) in form.radioData" :key="index+1">
                    <el-radio v-model="form.radio" :label="index">{{indexArr[index]}}</el-radio>
                    <div class="yk-input-show">
                      <!-- <el-input v-model="form.radioData[index]" placeholder="请输入内容" ></el-input> -->
                      <Editor v-model="form.radioData[index]" :config="editorconfig"/>
                      <!-- <Editor v-model="form.radioData[index]" height="42px" isShowMenus="false"/> -->
                    </div>
                    <i class="el-icon-close" @click="closeChoice(index)"></i>
                </div>
           </el-form-item>
           <!--  多选-->
           <el-form-item label="选项" class="yk-radioChoice" v-if="numType == 2">
             <el-checkbox-group v-model="checkList">
                <div class="yk-op-choice-child" v-for="(item,index) in form.radioData" :key="index+1">
                    <el-checkbox :label="index" @change="showAnswer()">{{indexArr[index]}}</el-checkbox>
                    <div class="yk-input-show">
                       <!-- <div style="position:absolute;right:0;top:0;width:100%;height:40px;border:1px solid black;"> -->
                         <Editor v-model="form.radioData[index]" :config="editorconfig"/>
                         <!-- <Editor v-model="form.radioData[index]" height="42px" isShowMenus="false"/> -->
                       <!-- </div> -->
                    </div>
                    <i class="el-icon-close" @click="closeChoice(index)"></i>
                </div>
              </el-checkbox-group>
           </el-form-item>
           <!-- <el-form-item label="选项" class="yk-cb-con" v-if="numType == 2">
               <el-checkbox-group v-model="checkList" class="yk-check-group">
                   <div class="yk-cd-con-child" v-for="(item,index) in form.radioData" :key="index+1">
                        <el-checkbox :label="index" @change="showAnswer()">{{indexArr[index]}}</el-checkbox>
                        <el-input v-model="form.radioData[index]" placeholder="请输入内容"></el-input>
                        <i class="el-icon-close" @click="closeChoice(index)"></i>
                   </div>
               </el-checkbox-group>
           </el-form-item> -->
            <!-- 判断题 -->
           <el-form-item label="正确答案" v-if="numType == 3">
               <div class="yk-correct-answer">
                  <el-radio :label="1" v-model="radioJudje">对</el-radio>
                  <el-radio :label="0" v-model="radioJudje">错</el-radio>
               </div>
           </el-form-item>
           <!-- 填空题 -->
           <el-form-item label="正确答案" v-if="numType == 4" class="yk-que-fillBlank">
                <div class="yk-que-fillBlank-con" v-for="(item,index) in form.blankData" :key="index+1" v-if="form.blankData.length > 0">
                    <span>{{index + 1}}</span>
                    <div class="yk-fill-input">
                        <el-input v-model="form.blankData[index]" placeholder="请输入内容"></el-input>
                    </div>
                    <i class="el-icon-close" @click="closeChoice(index)"></i>
                </div>
                <div v-if="form.blankData.length==0">
                  <div class="yk-fill-input">
                      <el-input :disabled="true"></el-input>
                  </div>
                </div>
                <div style="color:red;margin-left:10px;font-size:13px;" v-if="blankWarning">空格与填空数量不匹配</div>
           </el-form-item>

           <el-form-item label="添加选项" v-show="numType == 1|| numType == 2">
               <el-button type="primary" @click="addChoice(numType)">添加</el-button>
           </el-form-item>

           <el-form-item v-show="numType == 4">
               <span>至少在题干中输入 ____（4个连续的下划线）即可自动创建一个新的填空项。</span>
           </el-form-item>

          <el-form-item label="正确答案" v-if="numType == 1 || numType == 2">
               <div class="yk-correct-answer">
                   <span>{{correctAnswer}}</span>
               </div>
          </el-form-item>
            <!-- 简答题 -->
          <el-form-item label="参考答案" style="width:700px;" v-if="numType == 5">
                <Editor v-model="referenceAnswer" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="解析" style="width:700px;" v-if="numType != 6">
                <Editor v-model="analysisContent" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="解析附件" style="width:700px;" v-if="numType != 6">
                  <QuestionFile ref="analysisFileList" :url="urlAliyunOSS" :fileIds.sync="analysisFileIds" :filesList="analysisFilesList" :files.sync="analysisFileList"></QuestionFile>
           </el-form-item>
          <!-- 综合题 -->
          <div v-for="(item,index) in chrildQuetion" :key="index" v-if="numType == 6">
            <SingleChoice ref="SingleChoice" v-if="item.QuestionType ==1" :showChoice='showChoice' :childQuestion='item' :iSubmit='iSubmit' :sortOrder='item.sortOrder' :index='index'  @done="submitChildQuestions" @remove="remove"></SingleChoice>
            <Multiselect ref="Multiselect" v-if="item.QuestionType ==2" :showChoice='showChoice' :childQuestion='item' :iSubmit='iSubmit' :sortOrder='item.sortOrder' :index='index'  @done="submitChildQuestions" @remove="remove"></Multiselect>
            <TrueFalse ref="TrueFalse" v-if="item.QuestionType ==3" :showChoice='showChoice' :childQuestion='item' :iSubmit='iSubmit' :sortOrder='item.sortOrder' :index='index'  @done="submitChildQuestions"  @remove="remove"></TrueFalse>
          </div>

          <el-form-item label="" style="width:700px;" v-if="numType == 6">
                <el-button @click='addChildQuestion(1)'>添加单选题</el-button>
                <el-button @click='addChildQuestion(2)'>添加多选题</el-button>
                <el-button @click='addChildQuestion(3)'>添加判断题</el-button>
          </el-form-item>
          <div class="yk-operate-btn">
                <el-button @click="formReset">取消</el-button>
                <el-button @click="formSubmitNewAndGo" type="primary">保存后继续新增</el-button>
                <el-button @click="formSubmitNew" type="primary">保存</el-button>
          </div>
       </el-form>
   </div>
</template>

<script>
import SingleChoice from 'components/ObjectiveTest/Combine/SingleChoice.vue';
import Multiselect from 'components/ObjectiveTest/Combine/Multiselect.vue';
import TrueFalse from 'components/ObjectiveTest/Combine/TrueFalse.vue';
import { Message } from 'element-ui';
import { saveCombineQue } from 'api/v1.desgin.question.ts';
import QuestionFile from 'components/AliyunOSS/QuestionFile.vue';

export default {
  name: 'choice',
  components: {
    SingleChoice,
    Multiselect,
    TrueFalse,
    QuestionFile
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    knowledgeId: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    checkDiffcult: {
      type: String,
      default: ''
    },
    childQuestionList: {
      type: Array,
      default: []
    },
    showChoice: {
      type: Boolean,
      default: false
    },
    valueEditor: {
      type: String,
      default: ''
    },
    stemFiles: {
      type: Array,
      default: []
    },
    analysisFile: {
      type: Array,
      default: []
    }
  },
  created() {
    this.filesList = this.stemFiles;
    this.analysisFilesList = this.analysisFile;
  },
  data() {
    return {
      urlAliyunOSS: '/api/design/osssign/getsign',
      // 题干附件
      fileList: [],
      fileIds: [], // 附件Id
      filesList: [],
      // 解析附件
      analysisFileList: [],
      analysisFileIds: [],
      analysisFilesList: [],
      editorconfig: {
        toolbarInline: true,
        charCounterCount: false,
        toolbarVisibleWithoutSelection: true,
        placeholderText: '请输入内容',
        toolbarButtons: [
          'undo',
          'redo',
          'bold',
          'underline',
          'strikeThrough',
          'align',
          'insertLink',
          'insertImage'
        ],
        pluginsEnabled: ['image']
        // heightMin:100
      },
      form: {
        queType: [
          {
            value: 1,
            label: '单选题'
          },
          {
            value: 2,
            label: '多选题'
          },
          {
            value: 3,
            label: '判断题'
          },
          {
            value: 4,
            label: '填空题'
          },
          {
            value: 5,
            label: '简答题'
          },
          {
            value: 6,
            label: '综合题'
          }
        ],
        diffType: [
          {
            value: 1,
            label: '简单'
          },
          {
            value: 2,
            label: '一般'
          },
          {
            value: 3,
            label: '困难'
          }
        ],
        radio: -1, // 单选题题答案
        radioData: ['', '', '', ''], // 单选与多选的框
        blankData: [] // 填空题选项与答案
      },
      stemContent: '', // 题干
      referenceAnswer: '', // 简答题答案
      analysisContent: '',
      diffTypeValue: 1,
      indexArr: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      fbIndexArr: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
      ],
      checkList: [], // 多选题答案
      correctAnswer: '',
      queDialogShow: false,
      radioJudje: 1, // 判断题题答案
      quetionId: '',
      numType: 1, // 题目类型,
      blankWarning: false,
      blankListLength: '',
      chrildQuetion: [],
      iSubmit: false,
      childQueInfo: [],
      isAdd: false
    };
  },
  computed: {},
  mounted() {
    this.setQuestionInfo();
  },
  watch: {
    'form.radio': function(val) {
      this.correctAnswer = this.indexArr[val];
    },
    checkList: function(val) {
      let answer = '';
      for (let i = 0; i < val.length; i++) {
        answer += this.indexArr[val[i]] + '；';
      }
      this.correctAnswer = answer;
    },
    data: function() {
      this.setQuestionInfo();
    },
    stemContent: function(val) {
      // var index = this.numType;
      // var conLength = val.length;
      var exArray = val.substr(3).split('</p>');
      var blankArr = exArray[0].match(/_{4,}/g);
      //   var blankContent = $("p")
      //     .text()
      //     .substr(18, conLength);
      //   var blankArr = blankContent.match(/_{4,}/g);
      // if (blankArr) {
      var blankLength = blankArr ? blankArr.length : 0;
      this.blankListLength = blankLength;
      let arr = [];
      if (blankLength >= 1) {
        for (let i = 0; i < blankLength; i++) {
          // arr[i] = arr[i] || '';
          if (this.data) {
            arr[i] = this.data.Answers[i] ? this.data.Answers[i] : '';
          } else {
            arr[i] = arr[i] || '';
          }
        }
      }
      this.form.blankData = arr;
      if (blankLength !== this.form.blankData.length) {
        this.blankWarning = true;
      } else if (blankLength === this.form.blankData.length) {
        this.blankWarning = false;
      }
      // }
    },
    showChoice: function(val) {
      if (val) {
        this.chrildQuetion = this.childQuestionList;
      }
    },
    stemFiles: function(val) {
      let list = [];
      let ids = [];
      val.forEach(element => {
        list.push(element);
        ids.push(element.DocId);
      });
      this.filesList = list;
      this.fileList = list;
      this.fileIds = ids;
    },
    analysisFile: function(val) {
      let list = [];
      let ids = [];
      val.forEach(element => {
        list.push(element);
        ids.push(element.DocId);
      });
      this.analysisFilesList = list;
      this.analysisFileList = list;
      this.analysisFileIds = ids;
    }
  },
  methods: {
    // 添加选项
    addChoice: function(numType) {
      // 根据题型来增加
      let numTypeIndex = numType;
      if (numTypeIndex === '') {
        Message.warning('请先选择题型');
      }
      // 单选题多选题添加
      if (numTypeIndex === 1 || numTypeIndex === 2) {
        let dataRadioCopy = this.form.radioData;
        let lengthAdd = dataRadioCopy.length;
        if (lengthAdd === 7) {
          Message.warning('最多只能添加7个选项');
          return dataRadioCopy.splice(7, lengthAdd - 7);
        }
        this.form.radioData.push('');
      }
      if (numTypeIndex === 4) {
        this.form.blankData.push('');
      }
    },
    // 删除选项
    closeChoice: function(index) {
      if (this.numType === '') {
        Message.warning('未选择题型无法删除');
      }
      // 单选删除
      if (this.numType === 1) {
        this.form.radioData.splice(index, 1);
        if (this.form.radio === index) {
          this.form.radio = 0;
        } else if (this.form.radio > index) {
          this.form.radio = this.form.radio - 1;
        }
      }
      // 多选删除
      if (this.numType === 2) {
        let indexNum = this.checkList.indexOf(index);
        if (indexNum >= 0) {
          this.checkList.splice(indexNum, 1);
        } else {
          let list = [];
          for (let i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i] > index) {
              list.push(this.checkList[i] - 1);
            } else {
              list.push(this.checkList[i]);
            }
          }
          this.checkList = list;
        }
        this.form.radioData.splice(index, 1);
      }
      // 填空删除
      if (this.numType === 4) {
        this.form.blankData.splice(index, 1);
        if (this.blankListLength !== this.form.blankData.length) {
          this.blankWarning = true;
        } else if (this.blankListLength === this.form.blankData.length) {
          this.blankWarning = false;
        }
      }
    },
    // 切换题型
    changeType: function(val) {
      // this.correctAnswer = "";
      // this.form.radio = -1;
      // this.checkList = [];
      // this.radioData = ["", "", "", ""];
      // this.blankData = [];
      // this.stemContent = "";
      this.correctAnswer = '';
      this.form.radio = -1; // 单选题题答案
      this.checkList = []; // 多选题答案
      this.form.radioData = ['', '', '', '']; // 单选与多选的框
      this.form.blankData = []; // 填空题选项与答案
      this.stemContent = ''; // 题干
      this.referenceAnswer = ''; // 简答题答案
      this.analysisContent = '';
      this.radioJudje = 1; // 判断题题答案
      this.chrildQuetion = [];
    },
    // 保存后继续新增
    formSubmitNewAndGo: function() {
      let numIndex = this.numType;
      if (numIndex === '') {
        Message.warning('未选择题型无法提交');
      } else {
        if (numIndex === 6) {
          this.submitChildQuestion(1);
          this.isAdd = true;
          this.childQueInfo = [];
        } else {
          this.formSubmit(true);
          // this.cleanData();
        }
      }
    },
    // 保存题目
    formSubmitNew: function() {
      let numIndex = this.numType;
      if (numIndex === '') {
        Message.warning('未选择题型无法提交');
      } else {
        if (numIndex === 6) {
          this.submitChildQuestion(1);
          this.isAdd = false;
        } else {
          this.formSubmit(false);
        }
      }
    },
    // 传递给父组件的数据
    formSubmit: function(isAdd) {
      let numIndex = this.numType;
      if (numIndex === '') {
        Message.warning('未选择题型无法提交');
      }
      let correctAnswerArray = [];

      let selectArray = [];
      this.setCorrectArray(numIndex, correctAnswerArray, selectArray);
      this.$emit('newNodeEvent', {

        questionId: this.quetionId,
        quesType: this.numType,
        diffcult: this.diffTypeValue,
        content: this.stemContent,
        selects: selectArray,
        correctAnswers: correctAnswerArray,
        analysis: this.analysisContent,
        isAdd: isAdd,
        fileIds: this.fileIds,
        analysisFileIds: this.analysisFileIds
      });
      // this.cleanData();
    },
    setCorrectArray: function(type, answers, selects) {
      switch (type) {
        case 1:
          answers.push(this.form.radio);
          this.form.radioData.forEach(element => {
            selects.push(element);
          });
          break;
        case 2:
          this.checkList.forEach(element => {
            answers.push(element);
          });
          this.form.radioData.forEach(element => {
            selects.push(element);
          });
          break;
        case 3:
          answers.push(this.radioJudje);
          break;
        case 4:
          this.form.blankData.forEach(element => {
            answers.push(element);
          });
          break;
        case 5:
          answers.push(this.referenceAnswer);
          break;
        default:
          break;
      }
    },
    formReset: function() {
      this.$emit('closeDialog', this.queDialogShow);
      this.cleanData();
    },
    // 排序
    showAnswer: function() {
      this.checkList.sort();
    },
    // changeAnswer: function(index) {
    //   let isAdd = true;
    //   this.checkList.forEach(function(item, i) {
    //     if (this.indexArr[index] === item) {
    //       isAdd = false;
    //     }
    //   });
    // },
    // 赋值
    setQuestionInfo() {
      this.cleanData();
      if (this.data) {
        this.chrildQuetion = this.childQuestionList;
        this.numType = parseInt(this.data.QuestionType);
        this.diffTypeValue = parseInt(this.data.Difficulty);
        this.quetionId = this.data.Id;
        this.stemContent = this.data.Content;
        this.analysisContent = this.data.Analysis;
        this.gettCorrectArray(
          this.numType,
          this.data.Selects,
          this.data.Answers
        );
      }
    },
    gettCorrectArray: function(type, selects, answers) {
      switch (type) {
        case 1:
          this.form.radio = parseInt(answers[0]);
          this.form.radioData = selects;
          break;
        case 2:
          answers.forEach(element => {
            this.checkList.push(parseInt(element));
          });
          this.form.radioData = selects;
          break;
        case 3:
          this.radioJudje = parseInt(answers[0]);
          break;
        case 4:
          this.form.blankData = answers;
          break;
        case 5:
          this.referenceAnswer = answers[0];
          break;
        default:
          break;
      }
    },
    // 清空数据
    cleanData: function() {
      this.form.radio = -1; // 单选题题答案
      this.form.radioData = ['', '', '', '']; // 单选与多选的框
      this.form.blankData = []; // 填空题选项与答案
      this.stemContent = ''; // 题干
      this.referenceAnswer = ''; // 简答题答案
      this.analysisContent = '';
      this.diffTypeValue = 1;
      this.checkList = []; // 多选题答案
      this.correctAnswer = '';
      this.queDialogShow = false;
      this.radioJudje = 1; // 判断题题答案
      this.quetionId = '';
      this.numType = 1; // 题目类型
      this.iSubmit = false;
      this.filesList = [];
      this.analysisFilesList = [];
    },
    addChildQuestion: function(type) {
      let que = this.chrildQuetion;
      let sortOrder = que.length;
      this.chrildQuetion.push({
        QuestionType: type,
        sortOrder: sortOrder,
        radioData: ['', '', '', ''],
        radio: [-1]
      });
    },
    submitChildQuestion: function(obj) {
      this.iSubmit = true;
    },
    submitChildQuestions: function(obj) {
      this.childQueInfo.push({
        Content: obj.form.questionTitle,
        Type: obj.form.QuestionType,
        Difficult: 1,
        Selects: obj.form.radioData,
        CorrectSelect: obj.form.radio,
        Analysis: obj.form.analysisContent,
        SortOrder: obj.form.sortOrder
      });
      if (this.childQueInfo.length === this.chrildQuetion.length) {
        saveCombineQue(
          this.stemContent,
          this.valueEditor,
          parseInt(this.diffTypeValue),
          JSON.stringify(this.childQueInfo),
          this.courseId,
          this.fileIds,
          this.quetionId
        ).then(rst => {
          this.$message.success('添加成功');
          this.$emit('done', {
            pageIndex: 1,
            isAdd: this.isAdd
          });
          this.cleanData();
        });
      }
    },
    remove: function(val) {
      this.chrildQuetion.splice(val, 1);
    }
  }
};
</script>

<style lang="scss">
.yk-choice-main {
  .yk-question {
    display: flex;
  }
  .yk-radioChoice {
    .yk-op-choice-child {
      margin-top: 4px;
      label,
      .yk-input-show,
      i {
        display: inline-block;
      }
      .yk-input-show {
        width: 560px;
        border: 1px solid #ccc;
      }
    }
  }
  .yk-cb-con {
    .yk-check-group {
      .yk-cd-con-child {
        display: flex;
        margin-top: 5px;
        .el-input {
          margin: 0 5px;
          display: block;
          width: 550px;
        }
      }
      .el-icon-close {
        margin-top: 10px;
        font-size: 15px;
      }
    }
  }
  .yk-operate-btn {
    display: flex;
    justify-content: flex-end;
    button {
      margin-right: 25px;
    }
  }
  .yk-que-fillBlank {
    .yk-que-fillBlank-con {
      margin-top: 5px;
      span,
      .yk-fill-input,
      i {
        display: inline-block;
      }
      span {
        margin-left: 10px;
        color: gray;
      }
      .yk-fill-input {
        margin-left: 10px;
        width: 560px;
      }
    }
  }
}
.yk-choice-main-s-new {
  .el-checkbox-group {
    font-size: 15px;
    color: #000000;
  }
}
</style>

